import Alpine from 'alpinejs'
import qs from 'qs'

window.Alpine = Alpine

Alpine.store('signupModal', {
  open: false,
  body: '',
  success: true,
})

interface SignupModal {
  open: boolean
  body: string
  success: boolean
}

window.contactForm = () => {
  return {
    loading: false,
    formData: {
      first_name: '',
      last_name: '',
      email: '',
      organization: '',
      phone: '',
      message: '',
    },

    submitData() {
      this.loading = true
      const params = qs.stringify(this.formData)

      fetch(
        `https://script.google.com/macros/s/AKfycbw6vJwx5-rWtZAOrvFTQfDPxzCea72NOE17q025azCtN0gxXJM/exec?${params}`,
        {
          method: 'GET',
        },
      )
        .then((response) => {
          this.loading = false
          const modal = Alpine.store('signupModal') as SignupModal
          if (response.ok) {
            modal.success = true
            modal.body =
              'We have received your information and will be reaching out to you shortly.'
          } else {
            modal.success = false
            modal.body = 'Something went wrong. Please try again.'
          }
          modal.open = true
        })
        .catch(() => {
          this.loading = false
          const modal = Alpine.store('signupModal') as SignupModal
          modal.success = false
          modal.body = 'Something went wrong. Please try again.'
          modal.open = true
        })
    },
  }
}

Alpine.start()
